/**
 * Bundled Ionicons (was https://unpkg.com/ionicons@5.5.2 loader tags).
 * Only the icons actually referenced by <ion-icon name="..."> in this codebase
 * are registered — add to the map when you add a new name.
 */
import { addIcons } from 'ionicons';
import { defineCustomElements } from 'ionicons/dist/loader';
import {
    arrowForwardOutline,
    closeOutline,
    refreshOutline,
    mailOutline,
    lockClosedOutline,
    locationOutline,
    globeOutline,
    checkmarkOutline,
    callOutline,
} from 'ionicons/icons';

let registered = false;

export function registerIonicons() {
    if (registered) return;
    registered = true;
    addIcons({
        'arrow-forward-outline': arrowForwardOutline,
        'close-outline': closeOutline,
        'refresh-outline': refreshOutline,
        'mail-outline': mailOutline,
        'lock-closed-outline': lockClosedOutline,
        'location-outline': locationOutline,
        'globe-outline': globeOutline,
        'checkmark-outline': checkmarkOutline,
        'call-outline': callOutline,
    });
    defineCustomElements(window);
}
